<pp-error-box
  ppOpeningMessageKey="user_management_create_error_description_1"
  ppClosingMessageKey="user_management_create_error_description_2"
  [ppErrors]="errorMessages"
></pp-error-box>
